// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import categoryItemSharedStyles from "@pace/App/SharedStyles/categoryItemSharedStyles";
import { categoryDetailLinkListStyles } from "@pace/Overrides/Widgets/Category/CategoryDetailLinkList";
import { mergeWithCss, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

categoryDetailLinkListStyles.container = {
    gap: 0,
    css: css`
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
categoryDetailLinkListStyles.subCategoryNameLinkItem = {
    ...categoryItemSharedStyles.subCategoryNameLinkItem,
};
categoryDetailLinkListStyles.subCategoryNameLink = {
    ...categoryItemSharedStyles.subCategoryNameLink,
};
categoryDetailLinkListStyles.accordionSection = {
    ...categoryItemSharedStyles.accordionSection,
};
categoryDetailLinkListStyles.subCategoryWrapper = {
    ...categoryItemSharedStyles.subCategoryWrapper,
};
categoryDetailLinkListStyles.accordionWrapper = {
    ...categoryItemSharedStyles.accordionWrapper,
};

categoryDetailLinkListStyles.subcategoryFiltersHeaderText = {
    ...categoryItemSharedStyles.categoryFiltersHeaderText,
};
categoryDetailLinkListStyles.subcategoryListHeaderGridItem = {
    ...mergeWithCss(categoryItemSharedStyles.categoryListHeaderGridItem, {
        css: css`
            padding: 0;
        `,
    }),
};
categoryDetailLinkListStyles.categoryDropdownGridItem = {
    ...categoryItemSharedStyles.categoryDropdownGridItem,
};
